import React from 'react';
import Table from '../components/Table/Table';
import Columns from '../features/IngredientContainer/columns';
import useExcludedIngredients from '../features/IngredientContainer/hooks/useExcludedIngredients';
import useIncludeIngredients from '../features/IngredientContainer/hooks/useIncludeIngredients';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';

const IngredientsExcludedView = () => {
  const [isFetching, dishesRaw] = useExcludedIngredients();
  const dishes = toJS(dishesRaw, []);
  const [includeIngredients] = useIncludeIngredients();
  View.ExcludedIngredientsView.visit();

  function clickIncludeDishes(selectedData, callback) {
    const itemCodes = selectedData.map(row => row.data.itemCode);
    includeIngredients(itemCodes);
    callback();
  }

  return (
    <PaperContainer showProgress={isFetching}>
      <Table
        title="ingredient.excludedIngredientsTableTitle"
        data={dishes}
        columns={[
          Columns.IFoodIDExc,
          Columns.PresentationNameExc,
          Columns.ModifyDateExc
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        showLanguageSelector={false}
        actions={[{ label: 'Include', onClick: clickIncludeDishes }]}
      />
    </PaperContainer>
  );
};

export default IngredientsExcludedView;
